/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

import { NavigationExtras, Router } from '@angular/router';
import { AlertController, NavController, Platform } from '@ionic/angular';
import { Car } from 'src/app/models/car.entity';
import { DataService } from '../data.service';
import { Device } from './device';
import { Keyboard } from '@capacitor/keyboard';
import { Photo } from '@capacitor/camera';
import { Filesystem } from '@capacitor/filesystem';
import { BleClient, numbersToDataView, dataViewToNumbers} from '@capacitor-community/bluetooth-le';
import { Base } from './base';
import { WiFiConfigPayload, CmdGetStatus, WiFiConfigMsgType, CmdSetConfig } from 'src/assets/proto/proto-ts/wifi_config';


export class BleHelper {

  // Services
  static BATTERY_SERVICE = '0000dcfe-1212-efde-1523-785fef13d122';
  static WIFI_SERVICE = '021a9004-0382-4aea-bff4-6b3f1c5adfb4'

  // Characteristics
  static BATTERY_SENSOR_CHARACTERISTIC = '021aff51-0382-4aea-bff4-6b3f1c5adfb4';
  static GENERAL_CHARACTERISTIC = '00000031-1212-efde-1523-785fef13d122';
  static TIME_CHARACTERISTIC = '00000032-1212-efde-1523-785fef13d122';
  static SENSOR_CHARACTERISTIC = '00000033-1212-efde-1523-785fef13d122';
  static WIFI_CHARACTERISTIC = '021aff52-0382-4aea-bff4-6b3f1c5adfb4'
  static WIFI_SECURITY_CHARACTERISTIC = '021aff51-0382-4aea-bff4-6b3f1c5adfb4'
  static WIFI_SCAN_CHARACTERISTIC = '021AFF50-0382-4AEA-BFF4-6B3F1C5ADFB4'

  static configmessages = require('../../assets/proto/proto-ts/wifi_config.ts')
  static ctrlmessages = require('../../assets/proto/proto-ts/wifi_ctrl.ts')
  static scanmessages = require('../../assets/proto/proto-ts/wifi_scan.ts')

  debug: boolean = false

  // eslint-disable-next-line max-len
  constructor(public platform: Platform, public dataService: DataService, public router: Router, public navController: NavController, public alertController: AlertController) {
    //Base.console('info', 'constructing Base')
  }

  /*
  export enum Status {
  Success = 0,
  InvalidSecScheme = 1,
  InvalidProto = 2,
  TooManySessions = 3,
  InvalidArgument = 4,
  InternalError = 5,
  CryptoError = 6,
  InvalidSession = 7,
  UNRECOGNIZED = -1,
}
*/

  /***********************************
   * STATUS REQUEST
   */
  public static async prepareStatusRequest() {

    const vCmdGetStatus: CmdGetStatus = {}
    //// Base.log('[' + this._page + '] * prepareStatusRequest ')

    const cmd: WiFiConfigPayload = {
      msg: WiFiConfigMsgType.TypeCmdGetStatus,
      cmdGetStatus: vCmdGetStatus
    }
    //// Base.log('[' + this._page + '] * cmd prepareStatusRequest ')
    //// console.log(cmd)

    const encCmd = await BleHelper.configmessages.WiFiConfigPayload.encode(cmd).finish()
    //// Base.log('[' + this._page + '] * encCmd prepareStatusRequest ')
    //// console.log(encCmd)

    const dv = numbersToDataView(encCmd)
    //// Base.log('[' + this._page + '] dv prepareStatusRequest')
    //// console.log(dv.getUint8)
    //// console.log(dv.byteLength)

    return dv

  }

  public static async prepareStatusResponse(response) {

    const payloadDecoded = BleHelper.configmessages.WiFiConfigPayload.decode(dataViewToNumbers(response))
    //// Base.log('[' + this._page + '] dv prepareStatusResponse')
    //// console.log(payloadDecoded)

    //// Base.log('[' + this._page + '] status')
    const currentMsgType = payloadDecoded['msg']
    //// Base.log('[' + this._page + '] currentMsgType')
    //// console.log(currentMsgType)

    return payloadDecoded

  }


  /************************************
   * SET CONFIG
   */
  public static async prepareCmdSetConfig(bssid, ssid, password, selectedwifi) {

    const utf8Encode = new TextEncoder();

    const vCmdSetConfig: CmdSetConfig = {
      bssid: utf8Encode.encode(''),
      ssid: utf8Encode.encode(ssid),
      passphrase: utf8Encode.encode(password),
      channel: 0 //selectedwifi.channel
    }
    Base.log('[bleHelper] * vCmdSetConfig ' + vCmdSetConfig)

    const cmd: WiFiConfigPayload = {
      msg: WiFiConfigMsgType.TypeCmdSetConfig,
      cmdSetConfig: vCmdSetConfig
    }
    Base.log('[bleHelper] * cmd ')
    console.log(cmd)

    const encCmd = await BleHelper.configmessages.WiFiConfigPayload.encode(cmd).finish()
    //// Base.log('[' + this._page + '] * encCmd ')
    //// console.log(encCmd)

    const dv = numbersToDataView(encCmd)
    //// Base.log('[' + this._page + '] dv')
    //// console.log(dv.getUint8)
    //// console.log(dv.byteLength)

    return dv
  }

  public static async connectToBTDeviceByLabel(label: string) {

    return await BleClient.requestLEScan(
      { name: label },
      (result) => {
        //this.dataService.connectToBTDevice(dev)
        return BleHelper.connectToBTDeviceForId(result['device']['deviceId'])
      }
    )
  }

  private static async connectToBTDeviceForId(devId: string) {

      //Base.console('method', 'BleHelper: ConnectToBTDevice');

      await BleClient.initialize({ androidNeverForLocation: true }).then(() => {
        setTimeout(async () => {
          //Base.console('info', '***********************************')
          //Base.console('info', 'Connect to ' + devId)
          //Base.console('info', devId)
          BleClient.connect(devId).then((_) => {
            //Base.console('info', 'Connected to ' + devId)
          })
          //Base.console('info', '***********************************')

        }, 5000)
      })
  }

}
